import { connect } from 'react-redux'
import { getConfigurationRoot } from '../../configuration/selectors'
import AdminConfiguration from '../components/adminConfiguration'

const mapStateToProps = state => ({
  rootNode: getConfigurationRoot(state),
  config: {
    create: [
      {
        action: 'neue Konfiguration',
        mutation: 'createListMutation',
        res: 'createList',
        variables: id => ({
          list: {
            template: 'IconTile',
            title: 'neue Konfiguration',
            parent: id,
          },
        }),
      },
      {
        action: 'neue Option',
        mutation: 'createOptionMutation',
        res: 'createOption',
        variables: id => ({
          option: {
            title: 'neue Option',
            parent: id,
          },
        }),
      },
    ],
    drag: {
      List: {
        mutation: 'updateListMutation',
        variables: (id, children) => ({
          list: {
            id,
            children,
          },
        }),
      },
      Root: {
        mutation: 'updateRootMutation',
        variables: (id, children) => ({
          root: {
            id,
            children,
          },
        }),
      },
    },
  },
})

export default connect(
  mapStateToProps,
  null,
)(AdminConfiguration)



// WEBPACK FOOTER //
// ./src/modules/admin/containers/adminConfiguration.js